<script setup>
import SubjectGrid from '@/components/registry/SubjectGrid.vue'
</script>
<template>
  <subject-grid />
</template>
